<template>
  <div class="filter">
    <component
      :is="componentType"
      v-model="selectedProxy"
      :label="label"
      :options="options"
      :placeholder="placeholder"
      :show-reset="showReset"
      :show-selections="showSelections"
    />
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    modelValue?: string[]
    include?: (string | number)[]
    label?: string
    placeholder?: string
    showSelections?: boolean
    isMultiSelect?: boolean
    useSingularTerm?: boolean
  }>(),
  {
    modelValue: () => [],
    include: () => [],
    label: 'I am...',
    placeholder: 'All Audiences',
    showSelections: true,
    isMultiSelect: true,
    useSingularTerm: false,
  },
)
const emit = defineEmits(['update:modelValue'])
const { fetchAudiences } = useStoryblokDataSources()
const { data: audiences } = await fetchAudiences()
const selected = computed({
  get: () => {
    return props.modelValue
  },
  set: (value) => {
    emit('update:modelValue', value)
  },
})

const componentType = computed(() =>
  getFormkitSelectComponentName(props.isMultiSelect),
)
const options = computed(() => {
  let availableOptions = [...(audiences.value || [])]

  // remove all option
  availableOptions = availableOptions.filter((item) => item?.value !== 'all')

  if (props.include.length && !props.include.includes('all')) {
    availableOptions = availableOptions.filter((item) =>
      props.include.includes(item.value),
    )
  }

  return availableOptions.map((option) => ({
    label: props.useSingularTerm ? option.singularTerm : option.name,
    value: option.value,
  }))
})
const showReset = computed(() => props.isMultiSelect)

const selectedProxy = computed({
  get: () => selected.value,
  set: (value) => {
    emit('update:modelValue', value)
    selected.value = value
  },
})
</script>
